import {
	AdminRoutes,
	AnalyzerRoutes,
	AutoEuropeToolRoutes,
	BatchRoutes,
	DsRepricingRoutes,
	HomeRoute,
	NotFoundRoute,
	OneWayRoutes,
	RealTimeRoutes,
	reportRoutes,
	RootRoute,
	SessionRoutes,
	UserSettingsRoutes,
	BusinessLogisticsRoutes,
	MyBusinessRoutes,
} from 'Pages'


const routes = userData => ([
	RootRoute,
	HomeRoute,
	AnalyzerRoutes(userData),
	reportRoutes(userData),
	...OneWayRoutes(userData),
	RealTimeRoutes,
	...MyBusinessRoutes(userData),
	...BusinessLogisticsRoutes(userData),
	...AutoEuropeToolRoutes(userData),
	...DsRepricingRoutes(userData),
	BatchRoutes(userData),
	UserSettingsRoutes,
	AdminRoutes(userData),
	...SessionRoutes,
	NotFoundRoute,
])

export default routes